<script>
import { get } from 'lodash';
import { mapActions } from 'vuex';

import PageProps from 'components/mixins/page-props';
import RedirectLogged from 'components/mixins/redirect-logged';

import FormJoinInstance from './form-join-instance';

export default {
  name: 'page-join-instance',
  mixins: [
    PageProps,
    RedirectLogged,
  ],
  props: {
    token: {
      required: false,
      default: null,
    },
  },
  components: {
    FormJoinInstance,
  },
  data() {
    return {
      type: null,
    };
  },
  methods: {
    ...mapActions([
      'PersonAcceptInvitation',
    ]),
    onFormSubmit(data) {
      const payload = get(data, 'payload');

      this.PersonAcceptInvitation({
        type: this.type,
        payload,
      }).then((data) => {
        this.successNotification({ message: 'message.success_registration' });
        const token = get(data, 'token');
        this.loginWithToken(token);
      }).catch((error) => {
        console.error(error);
        this.errorNotification();
      });
    },
  },
  computed: {
    InvitationAccept() {
      return this.$store.getters.InvitationAccept(this.type);
    },
    InvitationPreAccept() {
      return this.$store.getters.InvitationPreAccept(this.type);
    },
  },
  created() {
    this.$store.dispatch('GetInvitationPreAccept', { type: this.type, query: { token: this.token } });
    this.$store.dispatch('InitPersonAcceptInvitation', { type: this.type });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearInvitationPreAccept', { type: this.type });
    this.$store.dispatch('ClearInvitationAccept', { type: this.type });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/shared/join-instance/page-join-instance.vue